import SmartMateriaUITable from './../../generic/SmartMateriaUITable'
import { apiDelete, apiPost } from '../../generic/Api_Functions'
import { apiGet } from './../../generic/Api_Functions'
import AddElementQuantity from './../../generic/smartAddElement/AddElementQuantity'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { useAuthorization } from '../../generic/hooks/useAuthorization'
import { IconButton } from '@mui/material'
import { useState } from 'react'
import { TextSnippetOutlined } from '@mui/icons-material'
import { SmartDialog } from '../../generic/utilities/SmartDialog'
import Document from '../document/Document'

const FixtureAssembly = (props) => {
  // Historia 170 (J4b, S103) — `preselectedRecord` additive, optional, inert when absent (every OTHER
  // caller): `FixtureAssemblyReference.jsx` forwards this when a document repository row's "Open
  // associated record" preselects a FIXTURE_ASSEMBLY inside this reference.
  const { referenceId, referenceName, preselectedRecord = null } = props
  const { t_ } = useSmartTranslation()
  const isUserAuthorized = useAuthorization()

  const [fixtureAssemblyRow, setFixtureAssemblyRow] = useState(null)
  const [showDocument, setShowDocument] = useState(false)
  const [isDownloadingFile, setIsDownloadingFile] = useState(false)
  const [editing, setEditing] = useState(false)
  const columns = [
    {
      name: t_('Code'),
      field: 'code',
      edit: false,
      charLimit: 60,
      mandatory: true,
      unique: true,
      readonly: true
    },
    {
      name: t_('Name'),
      field: 'name',
      charLimit: 80,
      mandatory: true
    },
    {
      name: t_('Description'),
      field: 'description',
      charLimit: 200
    },
    {
      name: t_('Location'),
      field: 'device.name',
      type: 'select',
      edit: {
        source: async () => {
          return await apiGet('devicesBasicData')
        },
        id: 'id',
        field: 'name'
      }
    }
  ]

  const actions = {
    create: {
      fetchFunction: null,
      render: (extraFunctions) => {
        const handleAlert = extraFunctions.showAlert
        return (
          <AddElementQuantity
            title={t_('ADD RECORD')}
            endpoint='fixtureAssembly/create'
            parameter={referenceId}
            referenceName={referenceName}
            onAlert={handleAlert}
            disable={!isUserAuthorized('ADD_FIXTURE_ASSEMBLY')}
          />
        )
      }
    },
    edit: {
      fetchFunction: (row) => {
        return apiPost('fixtureAssembly', row)
      },
      disabled: !isUserAuthorized('EDIT_FIXTURE_ASSEMBLY')
    },
    delete: {
      fetchFunction: (pagination) => {
        if (Array.isArray(pagination)) {
          // When one selected instead of the pagination we get an array with a unique element that is the row
          const newPagination = {
            page: 0,
            size: -1,
            columns: [],
            genericSearch: '',
            rows: [],
            allSelected: false,
            primaryKeys: [
              'id'
            ],
            sortKey: [],
            sortMode: []
          }
          pagination.map((item) => newPagination.rows.push(item.id))
          pagination = newPagination
        }
        return apiDelete('fixtureAssembly/' + referenceId, pagination)
      },
      disabled: !isUserAuthorized('DELETE_FIXTURE_ASSEMBLY')
    },
    custom: [
      {
        name: 'Documents',
        render: (row) => {
          return (
            <IconButton>
              <TextSnippetOutlined />
            </IconButton>
          )
        },
        disabled: (editing || !isUserAuthorized('DOCUMENTS_FIXTURE_ASSEMBLY')),
        onClick: (row) => {
          setFixtureAssemblyRow(row)
          setShowDocument(true)
        }
      }
    ]
  }

  return (
    <>
      <SmartDialog
        closeCallback={() => setShowDocument(false)}
        accept={false}
        cancel={false}
        close
        renderComponent={<Document reference={fixtureAssemblyRow} resourceType='FIXTURE_ASSEMBLY' isDownloadingFile={isDownloadingFile} setIsDownloadingFile={setIsDownloadingFile} />}
        setOpen={showDocument}
      />
      <SmartMateriaUITable
        tableTuneUniqueKey='fixtureAssembly'
        columns={columns}
        title={t_('Fixture Assembly') + ' - ' + referenceName}
        dataFetch={referenceId ? 'fixtureAssembly/' + referenceId : []}
        actions={actions}
        multipleSelection
        pageable
        preselectedRecord={preselectedRecord}
        editingRow={(event) => setEditing(event)}
      />
    </>
  )
}

export default FixtureAssembly
